<template>
    <div id="inspection-photo">
        <div class="filter-bar">
            <el-select v-model="shopId" placeholder="选择店铺" clearable size="small" style="width:160px">
                <el-option v-for="s in shops" :key="s.shop_id" :label="s.shop_name" :value="s.shop_id"></el-option>
            </el-select>
            <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width:280px"></el-date-picker>
            <el-button type="primary" size="small" @click="search">查询</el-button>
        </div>

        <el-table :data="tableData" border stripe v-loading="loading" style="width:100%">
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="shop_name" label="店铺" width="140"></el-table-column>
            <el-table-column prop="user_name" label="拍照人" width="120">
                <template slot-scope="scope">
                    <span>{{ scope.row.user_name || scope.row.open_id }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="photo_count" label="照片数" width="80"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="时间" width="170">
                <template slot-scope="scope">{{ formatDate(scope.row.created_at) }}</template>
            </el-table-column>
            <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="showDetail(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-wrap">
            <el-pagination
                :current-page="page"
                :page-size="pageSize"
                :total="total"
                layout="total, prev, pager, next"
                @current-change="onPageChange"
            ></el-pagination>
        </div>

        <el-dialog title="验货详情" :visible.sync="detailVisible" width="680px">
            <div class="detail-info" v-if="detailRecord">
                <p><strong>店铺：</strong>{{ detailRecord.shop_name }}</p>
                <p><strong>拍照人：</strong>{{ detailRecord.user_name || detailRecord.open_id }}</p>
                <p><strong>时间：</strong>{{ formatDate(detailRecord.created_at) }}</p>
                <p><strong>照片数量：</strong>{{ detailRecord.photo_count }}</p>
                <p v-if="detailRecord.remark"><strong>备注：</strong>{{ detailRecord.remark }}</p>
            </div>
            <div class="photo-grid">
                <img v-for="(url, idx) in detailPhotos" :key="idx" :src="url" referrerpolicy="no-referrer" class="photo-thumb" @click="previewImage(idx)">
            </div>
        </el-dialog>

        <el-dialog :visible.sync="previewVisible" :append-to-body="true" custom-class="full-image-dialog" :show-close="true">
            <div class="full-image-container" @wheel.prevent="handleWheel" @mousedown="onDragStart" @mousemove="onDragMove" @mouseup="onDragEnd" @mouseleave="onDragEnd">
                <img :src="detailPhotos[previewIndex]" referrerpolicy="no-referrer" class="full-img" :style="imageTransformStyle" draggable="false" />
                <div class="full-image-controls">
                    <el-button v-show="detailPhotos.length > 1" @click="prevImage" icon="el-icon-arrow-left" circle></el-button>
                    <el-button @click="zoomOut" icon="el-icon-minus" circle :disabled="imageScale <= 0.5"></el-button>
                    <span class="zoom-text" @click="resetZoom">{{ Math.round(imageScale * 100) }}%</span>
                    <el-button @click="zoomIn" icon="el-icon-plus" circle :disabled="imageScale >= 5"></el-button>
                    <span v-show="detailPhotos.length > 1" class="page-text">{{ previewIndex + 1 }}/{{ detailPhotos.length }}</span>
                    <el-button v-show="detailPhotos.length > 1" @click="nextImage" icon="el-icon-arrow-right" circle></el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'inspection-photo',
    data() {
        return {
            shopId: '',
            dateRange: null,
            loading: false,
            tableData: [],
            total: 0,
            page: 1,
            pageSize: 20,
            shops: [],
            detailVisible: false,
            detailRecord: null,
            detailPhotos: [],
            previewVisible: false,
            previewIndex: 0,
            imageScale: 1,
            translateX: 0,
            translateY: 0,
            dragging: false,
            dragStartX: 0,
            dragStartY: 0,
            lastTranslateX: 0,
            lastTranslateY: 0,
        }
    },
    computed: {
        imageTransformStyle() {
            return {
                transform: `scale(${this.imageScale}) translate(${this.translateX}px, ${this.translateY}px)`,
                cursor: this.imageScale > 1 ? (this.dragging ? 'grabbing' : 'grab') : 'default',
                transition: this.dragging ? 'none' : 'transform 0.15s ease',
            };
        },
    },
    watch: {
        previewVisible(val) {
            if (!val) this.resetZoom();
        },
        previewIndex() {
            this.resetZoom();
        },
    },
    created() {
        this.fetchShops();
        this.getList();
    },
    methods: {
        fetchShops() {
            this.$http.get('smart_shops').then(res => {
                this.shops = res || [];
            }).catch(() => {});
        },
        getList() {
            this.loading = true;
            let params = { page: this.page, page_size: this.pageSize };
            if (this.shopId) params.shop_id = this.shopId;
            if (this.dateRange && this.dateRange[0]) params.start_date = this.dateRange[0];
            if (this.dateRange && this.dateRange[1]) params.end_date = this.dateRange[1];

            this.$http.get('photo/admin/inspection_records', { params }).then(res => {
                this.tableData = res.list || [];
                this.total = res.total || 0;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        search() {
            this.page = 1;
            this.getList();
        },
        onPageChange(val) {
            this.page = val;
            this.getList();
        },
        zoomIn() {
            if (this.imageScale < 5) this.imageScale = Math.min(5, this.imageScale + 0.25);
        },
        zoomOut() {
            if (this.imageScale > 0.5) {
                this.imageScale = Math.max(0.5, this.imageScale - 0.25);
                if (this.imageScale <= 1) { this.translateX = 0; this.translateY = 0; }
            }
        },
        resetZoom() {
            this.imageScale = 1;
            this.translateX = 0;
            this.translateY = 0;
            this.dragging = false;
        },
        handleWheel(e) {
            if (e.deltaY < 0) { this.zoomIn(); } else { this.zoomOut(); }
        },
        onDragStart(e) {
            if (this.imageScale <= 1) return;
            this.dragging = true;
            this.dragStartX = e.clientX;
            this.dragStartY = e.clientY;
            this.lastTranslateX = this.translateX;
            this.lastTranslateY = this.translateY;
        },
        onDragMove(e) {
            if (!this.dragging) return;
            this.translateX = this.lastTranslateX + (e.clientX - this.dragStartX) / this.imageScale;
            this.translateY = this.lastTranslateY + (e.clientY - this.dragStartY) / this.imageScale;
        },
        onDragEnd() {
            this.dragging = false;
        },
        previewImage(idx) {
            this.previewIndex = idx;
            this.previewVisible = true;
        },
        prevImage() {
            if (this.previewIndex > 0) {
                this.previewIndex--;
            } else {
                this.previewIndex = this.detailPhotos.length - 1;
            }
        },
        nextImage() {
            if (this.previewIndex < this.detailPhotos.length - 1) {
                this.previewIndex++;
            } else {
                this.previewIndex = 0;
            }
        },
        showDetail(row) {
            this.detailRecord = row;
            if (Array.isArray(row.photo_urls)) {
                this.detailPhotos = row.photo_urls;
            } else {
                try {
                    this.detailPhotos = JSON.parse(row.photo_urls);
                } catch (e) {
                    this.detailPhotos = [];
                }
            }
            this.detailVisible = true;
        },
        formatDate(d) {
            if (!d) return '';
            return d.replace('T', ' ').substring(0, 19);
        },
    }
}
</script>

<style lang="scss" scoped>
.filter-bar {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 16px;
}
.pagination-wrap {
    margin-top: 16px;
    text-align: right;
}
.detail-info {
    margin-bottom: 16px;
    p { margin: 6px 0; color: #606266; }
    strong { color: #303133; }
}
.photo-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.photo-thumb {
    width: 150px;
    height: 150px;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;
    &:hover { opacity: 0.85; }
}
</style>
<style>
.full-image-dialog {
    width: 80% !important;
    max-width: 1200px;
}
.full-image-dialog .el-dialog__body {
    padding: 0;
}
.full-image-container {
    position: relative;
    background-color: #000;
    width: 100%;
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    user-select: none;
}
.full-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
.full-image-controls {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1;
}
.full-image-controls span {
    color: white;
    margin: 0 10px;
    font-size: 14px;
}
.full-image-controls .zoom-text {
    cursor: pointer;
    min-width: 48px;
    text-align: center;
}
.full-image-controls .zoom-text:hover {
    text-decoration: underline;
}
</style>
